import * as jsxRuntime from "C:\\Eidos!!!\\engekerne3.0\\77-eido-3.0-engraekkerne-2\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment